import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Ciudad de México, México'
}, {
  name: 'Carmen',
  city: 'Madrid, España'
}, {
  name: 'Lucía',
  city: 'Buenos Aires, Argentina'
}, {
  name: 'Rosa',
  city: 'Bogotá, Colombia'
}, {
  name: 'Elena',
  city: 'Santiago, Chile'
}, {
  name: 'Ana',
  city: 'Lima, Perú'
}, {
  name: 'Marta',
  city: 'Guadalajara, México'
}, {
  name: 'Patricia',
  city: 'Quito, Ecuador'
}, {
  name: 'Beatriz',
  city: 'Caracas, Venezuela'
}, {
  name: 'Gloria',
  city: 'San José, Costa Rica'
}, {
  name: 'Isabel',
  city: 'Montevideo, Uruguay'
}, {
  name: 'Esperanza',
  city: 'Medellín, Colombia'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-152">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-4 left-4 sm:bottom-8 sm:left-8 z-50 max-w-[280px] w-full" data-id="element-153">
          <div className="bg-brand-paper border-2 border-brand-terracotta rounded-xl p-3 shadow-2xl relative overflow-hidden ring-4 ring-brand-terracotta/20" data-id="element-154">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-terracotta via-brand-terracotta-light to-brand-terracotta" data-id="element-155" />

            <button onClick={() => setIsVisible(false)} className="absolute top-1.5 right-1.5 text-brand-muted/60 hover:text-brand-forest" aria-label="Cerrar" data-id="element-156">
              <XIcon className="w-3.5 h-3.5" data-id="element-157" />
            </button>

            <div className="flex items-center gap-2.5 pr-4" data-id="element-158">
              <div className="w-9 h-9 rounded-full bg-brand-forest text-brand-terracotta-light flex items-center justify-center font-bold text-base shrink-0 border-2 border-brand-terracotta" data-id="element-159">
                {currentBuyer.name.charAt(0)}
              </div>
              <div className="min-w-0" data-id="element-160">
                <p className="text-[12px] text-brand-text font-medium leading-tight" data-id="element-161">
                  <span className="font-bold text-brand-forest" data-id="element-162">
                    {currentBuyer.name}
                  </span>{' '}
                  de <span className="font-semibold" data-id="element-163">{currentBuyer.city}</span>{' '}
                  compró el Manual
                </p>
                <div className="flex items-center gap-1.5 mt-1" data-id="element-164">
                  <CheckCircle2Icon className="w-3 h-3 text-brand-terracotta" data-id="element-165" />
                  <span className="text-[10px] text-brand-terracotta font-bold" data-id="element-166">
                    Compra verificada
                  </span>
                  <span className="text-[10px] text-brand-muted" data-id="element-167">
                    · hace {timeAgo} min
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}